'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moduleRegistry = require('./module-registry');

var _moduleRegistry2 = _interopRequireDefault(_moduleRegistry);

var _baseLazyComponent = require('./base-lazy-component');

var _baseLazyComponent2 = _interopRequireDefault(_baseLazyComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactLazyComponent = function (_BaseLazyComponent) {
  _inherits(ReactLazyComponent, _BaseLazyComponent);

  function ReactLazyComponent(props, manifest) {
    _classCallCheck(this, ReactLazyComponent);

    var _this = _possibleConstructorReturn(this, (ReactLazyComponent.__proto__ || Object.getPrototypeOf(ReactLazyComponent)).call(this, props, manifest));

    _this.state = { component: null };
    return _this;
  }

  _createClass(ReactLazyComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.resourceLoader.then(function () {
        var component = _moduleRegistry2.default.component(_this2.manifest.component);
        _this2.setState({ component: component });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.component ? _react2.default.createElement(this.state.component, this.mergedProps) : null;
    }
  }]);

  return ReactLazyComponent;
}(_baseLazyComponent2.default);

exports.default = ReactLazyComponent;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-module-container/dist/src/react-lazy-component.js
// module id = 349
// module chunks = 0 1